import axios from 'axios';

// Use environment variable for API URL or default to localhost
// In production (cPanel), we should use the relative path or absolute domain
// Dynamic URL determination - robust against env vars in production
let BASE_URL;
const hostname = window.location.hostname;

if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    // Production/Network: Always use the current origin
    BASE_URL = window.location.origin;
} else {
    // Local Dev: Use env var or default
    BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
}
const API_URL = `${BASE_URL}/api/jobseeker/api/v1`; // JobSeeker Backend Unified

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});


api.interceptors.request.use((config) => {
    try {
        const user = localStorage.getItem('vetriaai_jobseeker_user');
        if (user) {
            const parsedUser = JSON.parse(user);
            if (parsedUser.token) {
                config.headers.Authorization = `Bearer ${parsedUser.token}`;
            }
        }
    } catch (error) {
        console.warn("Failed to load user token", error);
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem('vetriaai_jobseeker_user');
            if (
                !window.location.pathname.includes('/login') &&
                !window.location.pathname.includes('/test/share')
            ) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
